import React, { ReactNode, useRef } from 'react';
import ReactDOM from 'react-dom';
import { useLockBodyScroll } from '@/hooks';

interface ModalProps {
  isOpen: boolean;
  onClose?: () => void;
  children: ReactNode;
  maxWidth?: string;
  closeOnOutsideClick?: boolean;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  children,
  maxWidth = '520px',
  closeOnOutsideClick = true,
}) => {
  const modalRef = useRef<HTMLDivElement>(null);

  useLockBodyScroll(isOpen);

  /* ❌ Close on outside click */
  const handleOverlayClick = (e: React.MouseEvent) => {
    if (closeOnOutsideClick && modalRef.current && !modalRef.current.contains(e.target as Node)) {
      onClose?.();
    }
  };

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center px-3"
      onMouseDown={handleOverlayClick}
    >
      {/* Modal Box */}
      <div
        ref={modalRef}
        className="relative w-full bg-modelBg border border-white shadow-2xl rounded-2xl overflow-hidden z-[10000]"
        style={{ maxWidth }}
        onMouseDown={(e) => e.stopPropagation()}
      >
        {children}
      </div>

      {/* Overlay */}
      <div className="absolute inset-0 bg-black/50" />
    </div>,
    document.body
  );
};

export default Modal;
